var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.error)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v("Unable to locate coaching chat.")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }